<Navbar @active-profile-loaded="onActiveProfileLoaded" />

<nav class="navbar navbar-light bg-white border-bottom shadow-sm justify-content-between align-items-center px-3 px-md-4 publish-portal-navbar">
    <!-- Left: Hamburger Menu -->
    <div class="d-flex align-items-center">
      <a data-bs-toggle="offcanvas" href="#menu_items" role="button" aria-controls="menu_items"
        class="navbar-brand fs-3 text-dark">
        <i class="fa-solid fa-bars"></i>
      </a>
      <!-- Current Date (hidden on mobile, visible on tablet+) -->
      <p class="mb-0 ms-3 d-none d-md-block text-muted fw-medium">
        {{ current_date }}
      </p>
    </div>

    <!-- Center: Portal Name -->
    <div class="mx-auto text-center">
      <h3 class="mb-0 fw-bold portal-truncate" :title="$route.params.portal_name">
        {{ $route.params.portal_name }}
      </h3>
      <!-- Current Date (visible only on mobile) -->
      <p class="mb-0 d-md-none text-muted small">
        {{ current_date }}
      </p>
    </div>

    <!-- Right: Icons -->
    <div class="d-flex align-items-center publish-portal-actions">
      <CreateTagCategory v-if="client_features.show_categories" />
      <CreateSubject />
      <AllSubjects />
      <!-- all portals -->
      <div>
        <button class="btn btn-link text-dark fs-5 p-0" type="button" data-bs-toggle="offcanvas"
          href="#all_portals" aria-controls="all_portals" title="Open portals" aria-label="Open portals">
          <i class="bi bi-p-square-fill"></i>
        </button>
      </div>
    </div>
</nav>

 <div v-if="activeVoiceTab === 'your_feed'" class="container-fluid mt-2 p-1">
      <div class="row publish-feed-layout" :class="{ 'publish-feed-layout-full': !client_features.show_categories }">
        <!-- categories -->
        <div v-if="client_features.show_categories"
          class="col-12 col-md-4 col-lg-3 card bg-white border-0 rounded shadow-sm d-none d-md-block publish-filter-panel">
          <div class="bg-transparent card-header border-bottom publish-filter-header">
            <div class="d-flex justify-content-between align-items-start gap-2">
              <div>
                <p class="text-dark fw-bold mb-0 text-xs">Categories & tags</p>
              </div>
              <span v-if="selected_filter_count" class="publish-filter-count">
                {{ selected_filter_count }}
              </span>
            </div>
            <button
              v-if="selected_filter_count"
              type="button"
              class="btn btn-sm publish-filter-clear"
              @click="clear_selected_filters"
            >
              Clear filters
            </button>
          </div>
          <div class="mb-3 scrollable-container p-2 publish-filter-body">
            <!-- Dynamic categories -->
            <template v-if="categories.length">
              <div v-for="(category, index) in categories" :key="index" class="publish-filter-category border rounded overflow-hidden mb-2">
                <div class="d-flex justify-content-between align-items-center bg-light p-2 publish-filter-category-toggle">
                  <div class="min-w-0">
                    <h6 class="fw-bold mb-0 text-xs text-truncate">{{ category.name }}</h6>
                  </div>
                  <button type="button" class="btn btn-light border rounded d-inline-flex align-items-center justify-content-center p-0 publish-filter-collapse-btn" data-bs-toggle="collapse" :data-bs-target="`#collapse-${category.key}`" aria-expanded="true"
                    :aria-controls="`collapse-${category.key}`">
                    <i class="bi bi-chevron-down"></i>
                  </button>
                </div>
                <div :id="`collapse-${category.key}`" class="collapse show p-2 publish-filter-options">
                  <label
                    v-for="tag in category.tags"
                    :key="tag.id"
                    class="publish-filter-option d-flex align-items-center gap-2 rounded pointer mb-0"
                    :class="{ 'is-selected': isTagSelected(tag.id) }"
                    :for="`${category.key}-${tag.id}`"
                  >
                    <input type="checkbox" class="form-check-input checkbox-sm small mx-0 pointer"
                      :id="`${category.key}-${tag.id}`" :checked="isTagSelected(tag.id)"
                      @change="toggleTag(category.key, tag.id)" />
                    <span class="publish-filter-tag-name">{{ tag.name }}</span>
                  </label>
                </div>
              </div>
            </template>
            <div v-else class="publish-filter-empty">
              No tags available yet.
            </div>
          </div>
        </div>
        <div :class="client_features.show_categories ? 'col-12 col-md-8 col-lg-9' : 'col-12'">
          <div v-if="activeVoiceTab === 'your_feed'" class="publish-create-feed-shell">
            <CreateFeed
              ref="createFeed"
              @new_report="add_report"
              @report-updated="update_report"
              @new_temp_post="addTemporaryPost"
              :active-profile="activeProfile"
            />
          </div>

          <!-- Tag Filter Badge -->
          <div v-if="$route.query.tag_id" class="mb-3 d-flex align-items-center">
            <span class="badge bg-info text-dark me-2">
              Filtered by: {{ $route.query.tag_name }}
            </span>
            <button @click="clearTagFilter" class="btn btn-sm btn-outline-secondary">
              Clear Filter
            </button>
          </div>
          <!-- Temporary Post -->

          <div class="temporary-post posting-loader-card" v-if="temporaryPost" id="temp-post">
            <div class="posting-loader-icon" aria-hidden="true">
              <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
            </div>
            <div class="posting-loader-content">
              <div class="d-flex align-items-center justify-content-between gap-2">
                <p class="mb-0 fw-bold text-xs">Posting your feed</p>
                <span class="posting-loader-status">Saving</span>
              </div>
              <p class="mb-2 text-muted text-xxs text-truncate">{{ temporaryPost.report_name || 'Feed' }}</p>
              <div class="posting-loader-track" aria-hidden="true">
                <span></span>
              </div>
            </div>
          </div>
          <div v-if="!is_report_loading && filtered_reports.length === 0" class="empty-state publish-empty-state">
            <i class="bi bi-layout-text-window"></i>
            <p class="text-muted fst-italic small mb-0">No reports found</p>
          </div>
          <!-- Posts Grid -->
          <div class="scrollable-container scrollable-container-masonry-grid" ref="scrollContainer"
            @scroll="handleScroll">
            <div class="masonry-grid" ref="masonryGrid">
              <div v-for="report in filtered_reports" :key="report.id" class="masonry-item">
                <div class="card-bbc publish-report-card bg-white shadow-sm rounded position-relative overflow-visible p-2" @click="display_comment_modal(report)">
                      <!-- Three Dots Menu -->
                          <div class="publish-report-menu align-items-end d-flex flex-column"
                            @click.stop
                            v-if="can_manage_report(report)"
                          >
                             <a href="" class="text-dark" id="dropdownMenuButton" :id="`report-menu-${report.id}`" data-bs-toggle="dropdown" aria-expanded="false">
                              <i class="bi bi-three-dots-vertical"></i>
                            </a>
                            <ul class="dropdown-menu dropdown-menu-end lh-sm" :aria-labelledby="`report-menu-${report.id}`">
                              <li>
                                <button
                                  type="button"
                                  class="dropdown-item small fw-bold"
                                  @click.stop.prevent="open_create_feed_edit(report)"
                                >
                                  <i class="bx bxs-edit fs-6"></i> Edit
                                </button>
                              </li>
                              <li>
                                <a class="dropdown-item small fw-bold" href="" @click.prevent="delete_report(report.id)">
                                  <i class="bx bxs-trash-alt fs-6"></i> Delete
                                </a>
                              </li>
                            </ul>
                          </div>
                  <!-- Card body -->
                  <div v-if="hasTextContent(report.description) || client_features.show_categories && filteredCategoriesForReport(report).length || report.linkPreview" class="card-body publish-report-body pt-2">
                    <div class="d-flex flex-column gap-2">
                      <div v-if="client_features.show_categories && filteredCategoriesForReport(report).length" class="d-flex flex-wrap gap-2 pe-4">
                        <div v-for="category in filteredCategoriesForReport(report)" :key="category.name"
                          class="d-flex align-items-center flex-wrap publish-report-category">
                          <div class="fw-bold text-capitalize me-1 text-dark">{{ category.name }}:</div>
                          <span v-for="(tag, i) in category.tags" :key="tag.id"
                            class="text-primary text-capitalize me-1">
                            {{ tag.name }}<span v-if="i < category.tags.length - 1">,</span>
                          </span>
                        </div>
                      </div>
                    </div>

                    <div
                      v-html="get_description(report)"
                      class="ql-editor quill-content fs-6 lh-lg">
                    </div>

                    <div v-if="report.linkPreview" class="link-preview rounded mt-2 p-2 position-relative border">

                      <a :href="report.report_link" target="_blank" class="text-decoration-none">
                        <img v-if="report.linkPreview.image" :src="report.linkPreview.image"
                          class="img-fluid rounded" />
                        <div class="fw-bold mt-2">{{ report.linkPreview.title }}</div>
                        <div v-if="!report.linkPreview.image" class="text-muted small">{{ report.linkPreview.description
                          }}</div>
                      </a>
                    </div>
                  </div>

                  <!-- Files -->
                  <div class="d-flex flex-column p-2 publish-report-media" v-if="report.report_files && report.report_files.length > 0">
                    <!-- Uploaded Files -->
                    <div v-for="(fileObj, index) in filtered_files(report.report_files)" :key="index" class="mb-3">

                      <!-- AUDIO FILES -->
                      <div class="media-container video-audio mb-3" v-if="fileObj?.file?.url &&
                                  (fileObj.file.url.includes('.mp3') ||
                                  fileObj.file.url.includes('.wav'))">
                        <audio controls class="rounded-3 p-1">
                          <source :src="fileObj.file.url"
                            :type="fileObj.file.url.includes('.mp3') ? 'audio/mpeg' : 'audio/wav'" />
                        </audio>
                      </div>

                      <!-- VIDEO FILES -->
                      <div class="media-container video-audio mb-3"
                        v-else-if="fileObj?.file?.url && /\.(mp4|webm|ogg|ogv|mov|m4v|avi|mkv|wmv|flv|3gp|3g2)(?:$|[?#])/i.test(fileObj.file.url)">
                        <video controls class="media-item rounded-5" @click="display_comment_modal(report)">
                          <source :src="fileObj.file.url" />
                        </video>
                      </div>

                      <!-- OTHER FILES -->
                      <div v-else class="uploaded-file d-flex align-items-center justify-content-between p-3 mb-2 rounded shadow-sm" @click="open_preview(fileObj.file.url)">
                        <img v-if="fileObj?.file?.url" :src="getFileIcon(fileObj.file.url)"
                          class="file-icon small-icon" />
                        <span class="file-name text-break">{{ getFileName(fileObj?.file?.url) }}</span>
                        <a :href="fileObj?.file.url" download :title="getFileName(fileObj?.file?.url)"
                          class="download-btn" @click.stop>
                          <img src="https://cdn-icons-png.flaticon.com/128/724/724933.png" class="download-icon" />
                        </a>
                      </div>
                    </div>

                    <!-- Quill Images -->
                    <div  v-if="get_report_images(report).length>1" class="row g-2">
                      <div v-for="(src, i) in get_report_images(report).slice(0, 4)" :key="i"
                        class="col-6 position-relative">
                        <img :src="src" class="img-fluid rounded-2 publish-report-grid-image"
                          :class="{ 'publish-report-grid-image-more': i === 3 && get_report_images(report).length > 4 }"
                          @click="display_comment_modal(report)" />

                        <div v-if="i === 3 && get_report_images(report).length > 4"
                          class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center pointer"
                          @click="display_comment_modal(report)">
                          <span class="text-white fw-bold fs-4">+{{ get_report_images(report).length - 3 }}</span>
                        </div>
                      </div>
                    </div>
                    <div v-else-if="get_report_images(report).length">
                      <img :src="get_report_images(report)[0]" class="img-fluid rounded-2 w-100" @click="display_comment_modal(report)" />
                    </div>
                  </div>


                  <!-- Action Buttons Footer -->
                  <div class="py-2 border-top">
                    <div class="row g-0">
                      <!-- Like Button -->
                      <div class="col-4">
                        <div class="d-flex align-items-center justify-content-center gap-2 text-muted py-2">
                          <!-- Like button -->
                          <span v-if="!likedReports[report.id]" class="d-flex align-items-center fw-500 pointer publish-report-action-btn" @click.stop="likeReport(report)">
                            <i class="bi bi-hand-thumbs-up fs-5 text-purple"></i>
                            <span class="text-purple text-xs mx-1">({{report.total_likes}})</span>
                          </span>

                          <!-- Unlike button -->
                          <span v-else class="d-flex align-items-center fw-500 pointer publish-report-action-btn" @click.stop="unlikeReport(report)">
                            <i class="bi bi-hand-thumbs-up-fill fs-5 text-purple"></i>
                            <span class="text-xs mx-1">({{report.total_likes}})</span>
                          </span>

                        </div>
                      </div>

                      <!-- Comment Button -->
                      <div class="col-4">
                        <div
                          :class="`d-flex align-items-center justify-content-center gap-2 text-muted py-2 ${!report.can_comment ? 'comment-disabled' : 'pointer'}`"
                          @click="display_comment_modal(report)">
                          <i class="bi bi-chat fs-6"></i>
                          <span class="small fw-medium">({{report.total_comments}})</span>
                        </div>
                      </div>

                      <!-- Share Button -->
                      <div class="col-4">
                        <div class="d-flex align-items-center justify-content-center gap-2 text-muted py-2" @click.stop>
                          <input type="checkbox" :id="'menu-open-' + report.id" class="menu-open" name="menu-open" />
                          <label :for="'menu-open-' + report.id" class="menu-open-button d-flex align-items-center">
                            <i class="bi bi-share "></i>

                          </label>

                          <!-- Copy Link -->
                          <a @click="copyReportLinkToClipboard(report)" class="menu-item bg-white">
                            <span @click="closeMenu(report.id)">
                              <i class="bi bi-link fs-4 copy text-primary text-xxs"></i>
                            </span>
                          </a>

                          <!-- Facebook -->
                          <a :href="'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(baseUrl(report,'report'))"
                            target="_blank" class="menu-item facebook-share-btn bg-white" @click="closeMenu(report.id)">
                            <i class="bi bi-facebook"></i>
                          </a>

                          <!-- Twitter -->
                          <a :href="'https://twitter.com/intent/tweet?url=' + encodeURIComponent(baseUrl(report,'report'))"
                            target="_blank" class="menu-item twitter-share-btn bg-white" @click="closeMenu(report.id)">
                            <i class="bi bi-twitter-x"></i>
                          </a>

                          <!-- Gmail -->
                          <a :href="'mailto:?subject=Check%20this%20out&body=' + encodeURIComponent(baseUrl(report,'report'))"
                            target="_blank" class="menu-item gmail-share-btn bg-white" @click="closeMenu(report.id)">
                            <i class="bi bi-google"></i>
                          </a>

                          <!-- LinkedIn -->
                          <a :href="'https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(baseUrl(report,'report'))"
                            target="_blank" class="menu-item linkedin-share-btn bg-white" @click="closeMenu(report.id)">
                            <i class="bi bi-linkedin"></i>
                          </a>

                          <!-- WhatsApp -->
                          <a :href="'https://api.whatsapp.com/send?text=' + encodeURIComponent(baseUrl(report,'report'))"
                            target="_blank" class="menu-item whatsapp-share-btn bg-white" @click="closeMenu(report.id)">
                            <i class="bi bi-whatsapp"></i>
                          </a>

                          <!-- Telegram -->
                          <a :href="'https://t.me/share/url?url=' + encodeURIComponent(baseUrl(report,'report'))"
                            target="_blank" class="menu-item telegram-share-btn bg-white" @click="closeMenu(report.id)">
                            <i class="bi bi-telegram"></i>
                          </a>

                          <!-- Copy Toast -->
                          <div aria-live="polite" aria-atomic="true" class="position-fixed custom-toast">
                            <div id="copyToast" class="toast align-items-center text-bg-success border-0" role="alert"
                              aria-live="assertive" aria-atomic="true">
                              <div class="d-flex">
                                <div class="toast-body"></div>
                                <button type="button" class="btn-close btn-close-white me-2 m-auto"
                                  data-bs-dismiss="toast" aria-label="Close"></button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- </router-link> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
<!-- Row with categories + posts -->
<div class="tab-content scrollable-container mt-2">
  <!-- Voice Tab -->
  <div v-if="activeVoiceTab === 'voice'">
    <SurveyView />
  </div>

  <!-- Portal Requests Tab -->
  <div v-if="activeVoiceTab === 'requests'">
    <PortalRequest />
  </div>

  <!-- Documents Tab -->
  <div v-if="activeVoiceTab === 'documents'">
    <DocumentApproval />
  </div>

  <!-- Warehouse Tab -->
  <div v-if="activeVoiceTab === 'warehouse'">
    <DocumentWarehouse />
  </div>

  <div v-if="activeVoiceTab === 'approval_post' && user_details.user_role === 'admin'">
    <ApprovalPublishingPost />
  </div>
</div>


<div class="offcanvas offcanvas-start" tabindex="-1" id="menu_items" aria-labelledby="menu_items_label">
  <div class="offcanvas-header">
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
    <ul class="nav nav-pills d-flex flex-column mt-5" role="tablist">
      <li class="nav-item text-center ms-2 mt-2" role="presentation">
        <button class="nav-link text-xs fw-500 text-start w-100" data-bs-dismiss="offcanvas"
          :class="{ active: activeVoiceTab === 'your_feed' }" @click="activeVoiceTab = 'your_feed'">
          News & Articles
        </button>
      </li>
      <li class="nav-item text-center ms-2 mt-2" role="presentation">
        <button class="nav-link text-xs fw-500 text-start w-100" data-bs-dismiss="offcanvas"
          :class="{ active: activeVoiceTab === 'voice' }" @click="activeVoiceTab = 'voice'">
          Voice
        </button>
      </li>
      <li class="nav-item text-center ms-2 mt-2" role="presentation">
        <button class="nav-link text-xs fw-500 text-start w-100" data-bs-dismiss="offcanvas"
          :class="{ active: activeVoiceTab === 'requests' }" @click="activeVoiceTab = 'requests'">
          Requests
        </button>
      </li>
      <li class="nav-item text-center ms-2 mt-2" role="presentation">
        <button class="nav-link text-xs fw-500 w-100 text-start" data-bs-dismiss="offcanvas"
          :class="{ active: activeVoiceTab === 'documents' }" @click="activeVoiceTab = 'documents'">
          Document/Media Approval
        </button>
      </li>
      <li class="nav-item text-center ms-2 mt-2" role="presentation">
        <button class="nav-link text-xs fw-500 text-start w-100" data-bs-dismiss="offcanvas"
          :class="{ active: activeVoiceTab === 'warehouse' }" @click="activeVoiceTab = 'warehouse'">
          Document Warehouse
        </button>
      </li>

      <li v-if="user_details.user_role === 'admin'" class="nav-item text-center ms-2 mt-2" role="presentation">
        <button class="nav-link text-xs fw-500 text-start w-100" data-bs-dismiss="offcanvas"
          :class="{ active: activeVoiceTab === 'approval_post' }" @click="activeVoiceTab = 'approval_post'">
          Approval Post
        </button>
      </li>
    </ul>
  </div>
</div>

<div class="offcanvas offcanvas-end" tabindex="-1" id="all_portals" aria-labelledby="all_portals_label">
  <div class="offcanvas-header">
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body mt-3">
    <AllPortals data-bs-dismiss="offcanvas" />
  </div>
</div>

<StickyNav />

<ReportCommentModal v-if="comment_modal_visible" :report_data="report_data" :portal_admin="portal_admin"
  @hide_comment_comment="hide_comment_comment" />
